<template>
  <div>
    <h2>文书</h2>
    <Table class="table" :columns="col" :data="data.list">
      <template slot-scope="{ row }" slot="number">
        {{ row._index + 1 }}
      </template>
      <template slot-scope="{ row }" slot="school">
        {{ row.school_result.base_info.chn_name }}
      </template>
      <template slot-scope="{ row }" slot="teacher">
        {{
          row.ps_result && row.ps_result.teacher_result
            ? row.ps_result.teacher_result.name
            : "暂无"
        }}
      </template>
      <template slot-scope="{ row }" slot="ddl">
        {{ row.ddl ? $moment(row.ddl).format("YYYY-MM-DD") : "暂无" }}
      </template>
      <template slot-scope="{ row }" slot="status">
        <template v-if="row.ps_result.status">
          <span class="statu-item"
            >total: {{ row.ps_result.status.total }}</span
          >
          <span class="statu-item"
            >doing: {{ row.ps_result.status.status_0 }}</span
          >
          <span class="statu-item"
            >done: {{ row.ps_result.status.status_1 }}</span
          >
        </template>
      </template>

      <template slot-scope="{ row }" slot="action">
        <Button
          type="primary"
          size="small"
          @click="openDetail(row)"
          style="margin-right: 10px"
          >详情</Button
        >
        <Button type="error" size="small" class="add-btn" @click="deleteIt(row)"
          >删除</Button
        >
      </template>
    </Table>

    <div class="flex-right" style="margin-top: 10px">
      <Page
        :total="data.total"
        :current="data.page"
        :page-size="data.size"
        @on-change="getData"
      />
    </div>

    <Modal
      v-model="showDetail"
      title="Detail"
      width="850px"
      @on-cancel="showDetail = false"
    >
      <Table class="table" :columns="col2" :data="detailData.list">
        <template slot-scope="{ row }" slot="last_update">
          {{
            row.updateTime
              ? $moment(row.updateTime).format("YYYY-MM-DD")
              : $moment(row.createTime).format("YYYY-MM-DD")
          }}
        </template>
        <template slot-scope="{ row }" slot="uploader">
          {{
            (row.teacher_result && row.teacher_result.name) || "暂无"
          }}</template
        >
        <template slot-scope="{ row }" slot="status">
          {{ row.status ? "Done" : "Doing" }}</template
        >
        <template slot-scope="{ row }" slot="history">
          <Button
            type="primary"
            size="small"
            @click="openHistoryDetail(row)"
            style="margin-right: 10px"
            >详情</Button
          >
        </template>
        <template slot-scope="{ row }" slot="action">
          <Button
            type="default"
            size="small"
            @click="openHistoryDetail(row)"
            style="margin-right: 10px"
            >上传文件</Button
          >
          <Button type="primary" size="small" @click="openEditDetail(row)"
            >修改</Button
          >
        </template>
      </Table>
      <Button type="dashed" @click="openEditDetail({})" style="margin-top: 10px"
        >新增</Button
      >
    </Modal>

    <!-- 新建detail窗口 -->
    <Modal
      v-model="showEditDetail"
      title="文书内容"
      width="350px"
      @on-cancel="showEditDetail = false"
      @on-ok="saveEditDetail"
    >
      <Form :model="editDetailData" label-position="left" :label-width="80">
        <FormItem label="Essay">
          <i-input v-model="editDetailData.essay"></i-input>
        </FormItem>
        <FormItem label="Status">
          <i-switch
            v-model="editDetailData.status"
            :true-value="1"
            :false-value="0"
          />
          {{ editDetailData.status == 1 ? "done" : "doing" }}
        </FormItem>
      </Form>
    </Modal>

    <Modal
      v-model="showHistory"
      title="History"
      @on-cancel="showHistory = false"
      width="850px"
    >
      <Table class="table" :columns="col3" :data="historyData.history">
        <template slot-scope="{ row }" slot="number">
          {{ row._index + 1 }}
        </template>
        <template slot-scope="{ row }" slot="updateTime">
          {{ $moment(row.createTime).format("YYYY-MM-DD") }}
        </template>
        <template slot-scope="{ row }" slot="action">
          <Button
            type="default"
            size="small"
            @click="openFile(row)"
            style="margin-right: 10px"
            >打开文件</Button
          >
          <!-- <Button
            type="primary"
            size="small"
            @click="openEditFile(row)"
            style="margin-right: 10px"
            >修改/查看</Button
          > -->
        </template>
      </Table>
      
      <Button type="dashed" style="margin-top: 10px" @click="openEditFile"
        >添加</Button
      >
    </Modal>

    <Modal
      v-model="showFileEdit"
      title="添加文件"
      @on-cancel="showFileEdit = false"
      @on-ok="saveFile"
    >
      <uploadMainImg
        :key="fileEditObj.createTime"
        :srcData="fileEditObj.url"
        @change="changeUploadFile"
      ></uploadMainImg>
    </Modal>
  </div>
</template>

<script>
import uploadMainImg from "@/components/uploadMainImg.vue";
export default {
  components: { uploadMainImg },
  data() {
    return {
      data: {},
      col: [
        {
          title: "No.",
          slot: "number",
          align: "center",
          width: 80,
        },
        {
          title: "School",
          slot: "school",
          align: "center",
        },
        {
          title: "Type",
          key: "type",
          align: "center",
        },
        {
          title: "Major",
          key: "major",
          align: "center",
        },
        {
          title: "DDL",
          slot: "ddl",
          align: "center",
          width: 110,
        },
        {
          title: "Teacher",
          slot: "teacher",
          align: "center",
        },
        {
          title: "Status",
          slot: "status",
          align: "center",
          width: 210,
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: 160,
        },
      ],
      col2: [
        {
          title: "Essay",
          key: "essay",
          align: "center",
        },
        {
          title: "Last Update",
          slot: "last_update",
          align: "center",
        },
        {
          title: "Uploader",
          slot: "uploader",
          align: "center",
        },
        {
          title: "History",
          slot: "history",
          align: "center",
        },
        {
          title: "Status",
          slot: "status",
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: 200,
        },
      ],
      col3: [
        {
          title: "No.",
          slot: "number",
          align: "center",
          width: 80,
        },
        {
          title: "文件名",
          key: "url",
          align: "center",
        },
        {
          title: "Upload Time",
          slot: "updateTime",
          align: "center",
          width: 200,
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: 260,
        },
      ],
      schoolData: {},

      showDetail: false,
      detailData: {},
      selectedPs_id: false,

      showEditDetail: false,
      editDetailData: {},

      showHistory: false,
      historyData: [],

      showFileEdit: false,
      fileEditObj: {},
    };
  },
  methods: {
    async getData(page = 1) {
      let res = await this.api({
        url: "/ps/select",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
          page: page,
          size: 10,
        },
      });

      this.data = res;
    },

    async getAllSelectionSchool(page = 1) {
      let res = await this.api({
        url: "/school/selectSelection",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
          page: page,
          size: 10,
        },
      });

      this.schoolData = res;
    },

    openEditDetail(row = {}) {
      this.showEditDetail = true;
      this.editDetailData = row;
    },

    async saveEditDetail() {
      await this.api({
        url: "/ps/saveDetail",
        method: "post",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
        },
        data: {
          ...this.editDetailData,
          ps_id: this.selectedPs_id,
          status: this.editDetailData.status ? 1 : 0,
        },
      });
      this.$Message.success("保存成功");
      this.reflashDetail();
      this.getData(this.data.page);
    },

    async openDetail(row) {
      let ps_id;
      if (!row.ps_result) {
        // 新建ps
        let new_ps_result = await this.api({
          url: "/ps/save",
          method: "post",
          params: {
            token: this.$store.getters.token,
            ttoken: this.$store.getters.ttoken,
          },
          data: {
            student_id: this.$store.getters.selectedStudent._id,
            student_school_selection_id: row._id,
          },
        });
        ps_id = new_ps_result.msg;
        this.getData(this.data.page);
      } else {
        ps_id = row.ps_result._id;
      }

      let res = await this.api({
        url: "/ps/selectDetail",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
          ps_id: ps_id,
          page: 1,
          size: 99,
        },
      });
      this.selectedPs_id = ps_id;
      this.detailData = res;
      this.showDetail = true;
    },

    async reflashDetail() {
      let res = await this.api({
        url: "/ps/selectDetail",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
          ps_id: this.selectedPs_id,
          page: 1,
          size: 99,
        },
      });
      this.detailData = res;
    },
    async reflashDetailHistory() {
      let res2 = await this.api({
        url: "/ps/getDetailById",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          ps_detail_id: this.historyData._id,
        },
      });
      this.historyData = res2;
    },

    openFile(row) {
      window.open(row.url, "_blank");
    },

    openHistoryDetail(row) {
      this.showHistory = true;
      this.historyData = row;
    },

    openEditFile() {
      this.fileEditObj = {};
      this.showFileEdit = true;
    },

    changeUploadFile(val) {
      this.fileEditObj.url = val;
    },
    // 添加历史文件
    async saveFile() {
      await this.api({
        url: "/ps/uploadFile",
        method: "post",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
        },
        data: {
          ps_detail_id: this.historyData._id,
          url: this.fileEditObj.url,
        },
      });

      this.$Message.success("保存成功");
      this.reflashDetail();
      this.reflashDetailHistory();
    },
  },
  mounted() {
    if (!this.$store.getters.selectedStudent._id) {
      return;
    }
    // this.getAllSelectionSchool();
    this.getData();
  },
  watch: {
    "$store.getters.selectedStudent": async function () {
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
.statu-item {
  display: inline-block;
  margin: 0 5px;
}
</style>